import { useIntl } from "react-intl";

import {
  PaymentDetails,
  PaymentDetailsRow,
  PaymentDetailsTotalPriceRow,
} from "@/components/PaymentDetails";
import { TermsAndConditionsAlert } from "@/components/TermsAndConditionsAlert/TermsAndConditionsAlert";
import { formatCurrency } from "@/utils/currency";

type Props = {
  basePrice: number;
  promoCodeDiscount?: number;
  totalPrice: number;
};

export const OrderSummaryCard = ({
  basePrice,
  promoCodeDiscount,
  totalPrice,
}: Props) => {
  const intl = useIntl();

  return (
    <PaymentDetails
      title={intl.formatMessage({
        defaultMessage: "Order Summary",
        description: "Title for the order summary section",
      })}
      summary={<PaymentDetailsTotalPriceRow totalPrice={totalPrice} />}
      footer={<TermsAndConditionsAlert />}
    >
      <PaymentDetailsRow
        label={intl.formatMessage({
          defaultMessage: "Hotel price",
          description:
            "Line item label for the base hotel price in the order summary",
        })}
        value={formatCurrency(basePrice)}
      />

      {promoCodeDiscount ? (
        <PaymentDetailsRow
          label={intl.formatMessage({
            defaultMessage: "Promo code discount",
            description:
              "Line item label for the promo code discount in the price summary",
          })}
          value={formatCurrency(promoCodeDiscount, undefined, {
            prefix: "-",
          })}
          color="accent"
        />
      ) : null}
    </PaymentDetails>
  );
};
